export default "<div class=\"landing\">\n\t<mat-spinner [diameter]=\"50\" color=\"accent\"></mat-spinner>\n</div>\n";